import { Line, Rect, Group, Text } from 'react-konva';
import { PLATFORM_THEME_COLORS } from '@thinknet-gmbh/platform-common-ui';
import { COLUMN_WIDTH } from 'src/pages/gantt/gantt-calendar/gantt-view/gantt-view.constants';
import {
  DATE_COLUMN_WIDTH,
  HEADER_ROW_HEIGHT,
  DATE_COLUMN_INDENT,
} from 'src/pages/gantt/gantt-calendar/gantt-view/gantt-view.constants';

import { IHeaderLayer } from './header-layer.interfaces';
import EmployeeAvatar from './employee-avatar/employee-avatar.component';

const HeaderLayer = ({
  fullWidth,
  ganttData,
  t,
  onEmployeeClick,
  dateBarLeftOffset,
}: IHeaderLayer) => (
  <>
    <Group listening={false}>
      {/* Header row background layer */}
      <Rect
        x={0}
        y={0}
        width={fullWidth}
        height={HEADER_ROW_HEIGHT}
        perfectDrawEnabled={false}
        cornerRadius={[8, 8, 0, 0]}
        fill={PLATFORM_THEME_COLORS.tone.lightBlue}
      />

      {/* Date header column text */}
      <Text
        x={0}
        y={0}
        fontSize={14}
        fontStyle="bold"
        fontFamily="Inter"
        verticalAlign="middle"
        width={DATE_COLUMN_WIDTH}
        height={HEADER_ROW_HEIGHT}
        text={t('gantt:labels.date')}
        offsetX={-DATE_COLUMN_INDENT}
      />
    </Group>

    <Group>
      {ganttData.map(({ employee }, index) => {
        const columnStart = index * COLUMN_WIDTH + DATE_COLUMN_WIDTH;
        const columnEnd = columnStart + COLUMN_WIDTH;
        const { shadow } = PLATFORM_THEME_COLORS.grayVariations;
        const employeeAvatar = employee.avatarUrl;
        const employeeTextWidth = employeeAvatar ? HEADER_ROW_HEIGHT - 24 : HEADER_ROW_HEIGHT;

        return (
          <Group key={index}>
            {/* Header column line separator */}
            {index === 0 && (
              <Line
                points={[
                  columnStart,
                  DATE_COLUMN_INDENT,
                  columnStart,
                  HEADER_ROW_HEIGHT - DATE_COLUMN_INDENT,
                ]}
                stroke={shadow}
                strokeWidth={1}
              />
            )}

            <Line
              points={[
                columnEnd,
                DATE_COLUMN_INDENT,
                columnEnd,
                HEADER_ROW_HEIGHT - DATE_COLUMN_INDENT,
              ]}
              stroke={shadow}
              strokeWidth={1}
            />

            {/* Header column text */}
            <Group
              onMouseEnter={() => {
                document.body.style.cursor = 'pointer';
              }}
              onMouseLeave={() => {
                document.body.style.cursor = 'default';
              }}
              onClick={() =>
                onEmployeeClick({
                  target: employee,
                  entryView: {
                    x: columnStart - dateBarLeftOffset,
                    height: HEADER_ROW_HEIGHT,
                    width: COLUMN_WIDTH,
                  },
                })
              }
            >
              <Text
                ellipsis
                padding={6}
                wrap="none"
                fontSize={11}
                align="center"
                rotation={270}
                x={columnStart}
                fontFamily="Inter"
                text={employee.nickname || employee.name}
                y={employeeTextWidth}
                height={COLUMN_WIDTH}
                verticalAlign="middle"
                width={employeeTextWidth}
              />
              {employeeAvatar && <EmployeeAvatar startPointX={columnStart} url={employeeAvatar} />}
            </Group>
          </Group>
        );
      })}
    </Group>
    {/* Body top border */}
    <Line
      stroke={PLATFORM_THEME_COLORS.grayVariations.medium}
      strokeWidth={2}
      points={[0, HEADER_ROW_HEIGHT, fullWidth, HEADER_ROW_HEIGHT]}
    />
  </>
);

export default HeaderLayer;
